const negah ={
    PAGE_TITLE:"محصولات گروه نگاه",
    MORE:"اطلاعات بیشتر",
}

export default negah